export { default } from "./TabbyPromoSnippet.jsx";
